export default "__VITE_ASSET__DrB4ALer__"